import type { EditScannerConfigInput, ResponseError } from '@rtkwlf/rendall';
import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';

import { useRendallApi } from '../../use-rendall-api';

export const useEditScannerConfig = (
  scannerId: string,
  options?: Omit<
    UseMutationOptions<
      Response,
      ResponseError,
      EditScannerConfigInput,
      unknown
    >,
    'mutationFn'
  >,
) => {
  const api = useRendallApi();
  const { selectedOrganization } = useOrganizationContext();

  return useMutation({
    mutationFn: async (scannerConfig: EditScannerConfigInput) => {
      return await api
        .editScannerConfigRaw({
          editScannerConfigInput: scannerConfig,
          organizationId: selectedOrganization.id,
          scannerId,
        })
        .then((r) => r.raw);
    },
    ...options,
  });
};
